import React from 'react';
import styled from 'styled-components';
import {
  LoadingButton as LoadingButtonBase,
  LoadingButtonProps,
} from '@mui/lab';
import buttonStyles from './styles';
import { ButtonColor, ButtonSize } from './types';

export type Props = Omit<LoadingButtonProps, 'size'> & {
  variant?: 'contained' | 'outlined';
  color?: ButtonColor;
  size?: ButtonSize;
};

const StyledLoadingButton = styled(LoadingButtonBase)<
  LoadingButtonProps & { $size?: ButtonSize }
>`
  ${buttonStyles};
  padding-left: ${({ loading, loadingPosition }) =>
    loading && loadingPosition !== 'center' ? '40px' : 'auto'};
  &.MuiLoadingButton-loading.MuiLoadingButton-loadingPositionCenter {
    color: transparent;
  }
`;

StyledLoadingButton.defaultProps = {
  variant: 'contained',
  color: 'primary',
  loadingPosition: 'start',
};

// Suppress MUI warning about loadingPosition="start" without startIcon
// We intentionally use this configuration with our custom padding
if (StyledLoadingButton.propTypes) {
  StyledLoadingButton.propTypes = {
    ...StyledLoadingButton.propTypes,
    loadingPosition: () => null,
  };
}

const LoadingButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ size, ...rest }, ref) => {
    const muiSize =
      size === 'extraSmall' ? 'small' : (size as LoadingButtonProps['size']);
    return (
      <StyledLoadingButton ref={ref} size={muiSize} $size={size} {...rest} />
    );
  },
);

LoadingButton.displayName = 'LoadingButton';

export default LoadingButton;
